import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.company-verification', {
        url: '/companyVerification?vkey',
        component: 'companyVerification',
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/public/verification/company/company-verification.state.js